import React from "react";
import ForgotPasswordComponent from '@/components/login/forgot-password/forgot-password';
import Head from 'next/head';
import LandingLayout from "@/components/landing/home/LandingLayout";
const ForgotPassword = () => {
  return (
    <>
      <Head>
        <link
          rel="canonical"
          href={`${process.env.NEXT_PUBLIC_SITE_URL}login/forgot-password`}
        />
      </Head>
      <LandingLayout>
        <ForgotPasswordComponent />
      </LandingLayout>
    </>
  );
};

export default ForgotPassword;